var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangLongReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1600",
    "data-name": "Group 1600",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M192.065,21.305l-3.187-3.187a.75.75,0,1,0-1.059,1.059l3.188,3.188a.75.75,0,0,0,.525.216.778.778,0,0,0,.534-.216A.75.75,0,0,0,192.065,21.305Z",
    transform: "translate(-169.987 -16.196)",
    fill: "#e86262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M22.63,18.383a.75.75,0,0,0-1.059,0L18.383,21.57a.75.75,0,0,0,0,1.059.778.778,0,0,0,.534.216.75.75,0,0,0,.525-.216l3.188-3.187A.75.75,0,0,0,22.63,18.383Z",
    transform: "translate(-16.461 -16.461)",
    fill: "#e86262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M50,40.828a1.387,1.387,0,0,1-.009-.2h0A9,9,0,0,0,41.469,32.1h-.937a9,9,0,0,0-8.522,8.522h0a1.388,1.388,0,0,1-.009.2v.525a1.388,1.388,0,0,1,.009.2h0a9,9,0,0,0,8.522,8.541h.938a9,9,0,0,0,8.522-8.522h0a1.387,1.387,0,0,1,.009-.2v-.525Zm-3.75,1.012H41a.75.75,0,0,1-.75-.75v-5.25a.75.75,0,0,1,1.5,0v4.5h4.5a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-29 -29.091)",
    fill: "#e86262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangLongReminder);
export default __webpack_public_path__ + "static/media/CHANG_LONG_REMINDER.2edfff9019da16998d6408c6e988d535.svg";
export { ForwardRef as ReactComponent };